import AlignmentGrid from './AlignmentGrid';
import { AlignmentGridProps, AlignmentGridValueProps } from './types';

export type { AlignmentGridProps, AlignmentGridValueProps };
export default AlignmentGrid;
